import fetch from 'auth/FetchInterceptor'

const userService = {}
const api = '/users'
userService.get = async function (paginationQuery = '', query = '') {
  try {
    let url = `${api}${paginationQuery}${query}`
    const res = await fetch({
      url,
      method: 'get',
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}



userService.delete = async function (id) {
  try {
    const res = await fetch({
      url: `${api}/${id}`,
      method: 'delete',
    })
    //   const data = res.data.filter((cur) => cur.status !== 'Deleted')
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}


userService.getById = async function (id) {
  try {
    const res = await fetch({
      url: `${api}/get/${id}`,
      method: 'get',
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}



userService.create = async function (data) {
  try {
    const res = await fetch({
      url: `${api}/create-customer`,
      method: 'post',
      data: data,
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}

userService.getCurrentUserDetails = async function () {
  try {
    const res = await fetch({
      url: '/user/details',
      method: 'get',
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}

userService.establishSession = async function (token) {
  try {
    const res = await fetch({
      url: `${api}/auth/establish-session`,
      method: 'post',
      silent: true,
      ...(token && { tokenFromApi: token }),
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}

userService.signOutSession = async function () {
  try {
    const res = await fetch({
      url: `${api}/auth/sign-out`,
      method: 'post',
      silent: true,
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}

userService.createSubAdmin = async function (data) {
  try {
    const res = await fetch({
      url: `${api}/create-sub-admin`,
      method: 'post',
      data: data,
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}


userService.edit = async function (id, data) {
  try {
    const res = await fetch({
      url: `${api}/${id}`,
      method: 'patch',
      data: data,
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}

userService.blockUser = async function (id) {
  try {
    const res = await fetch({
      url: `${api}/${id}/hold`,
      method: 'patch',
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}

userService.unBlockUser = async function (id) {
  try {
    const res = await fetch({
      url: `${api}/${id}/activate`,
      method: 'patch',
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}

userService.editPermissions = async function (data, id) {
  try {
    const res = await fetch({
      url: `${api}/${id}/permissions`,
      method: 'patch',
      data: data,
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}

userService.updatePassword = async function (data) {
  try {
    const res = await fetch({
      url: `${api}/sub-adminPassword/update`,
      method: 'patch',
      data: data,
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}

userService.resetPasswordAdmin = async function (data) {
  try {
    const res = await fetch({
      url: '/user/password/reset/admin',
      method: 'put',
      data,
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}


userService.editSubadmin = async function (data, id) {
  try {
    const res = await fetch({
      url: `${api}/${id}`,
      method: 'put',
      data: data,
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}

export default userService;
